<template>
  <div>
    <!-- editDialog -->
    <v-dialog
      v-model="editDialog"
      persistent 
      max-width="800px"
      transition="dialog-transition"
    >
        <v-flex
          class="xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"
         >
          <v-flex class="xs12">
            <v-autocomplete
              v-model="editedOwnershipHistory.artwork_ownership_id"
              label="New Ownership"
              :items="ownerships"
              item-text="name"
              item-value="id"
              cache-items
              dense
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12">
            <v-text-field
              v-model="editedOwnershipHistory.note"
              name="note"
              label="Note"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-menu
              v-model="menu2"
              :return-value.sync="editedOwnershipHistory.change_date"
              ref="menu2"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              landscape
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                v-model="editedOwnershipHistory.change_date"
                slot="activator"
                label="Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                persistent
                color="black"
                v-model="editedOwnershipHistory.change_date"
                @input="$refs.menu2.save(editedOwnershipHistory.change_date)"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex class="xs12"></v-flex>
          <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
            <v-btn @click="editDialog = !editDialog">cancel</v-btn>
              <!-- :dark="!(editedOwnershipHistory.artwork_ownership_id == null || editedOwnershipHistory.artwork_ownership_id == '')" -->
            <v-btn
              @click="save_edited_artwork_ownership_history"
              >save</v-btn
            >
              <!-- :disabled="true" -->
                <!-- (editedOwnershipHistory.artwork_ownership_id == null || editedOwnershipHistory.artwork_ownership_id == '')" -->
          </v-flex>
        </v-flex>      
    </v-dialog>

    <v-layout column class="mt-0">
      <!-- <v-flex ml-3>
        <v-flex xs12>
          <v-icon color="black" small class="ml-2">adjust</v-icon>
          <b>{{ ownership_name(artwork.artwork_ownership_id) }}</b>
        </v-flex>
      </v-flex> -->

      <v-layout row wrap xs12 sm12 md12 mt-4 ml-0 mr-0 px-0 v-if="c_user.edit">

        <v-flex 
          text-xs-center ml-2 mr-2
          v-if="
            artwork.artwork_ownership_logs &&
              artwork.artwork_ownership_logs.length > 0
          "
        >
          Show Ownership History
          <v-btn icon small @click="showList = !showList" class="my-0 py-0">
            <v-icon v-if="!showList">expand_more</v-icon>
            <v-icon v-if="showList">expand_less</v-icon>
          </v-btn>
        </v-flex>

        <!-- <v-flex
          v-if="showUpload"
          class="xs12 ml-0 mr-1 pl-4 pr-4 pt-4 pb-3 mb-2 layout row wrap elevation-1 white"
        >
          <v-flex class="xs12">
            <v-autocomplete
              v-model="artwork_ownership_log.artwork_ownership_id"
              label="New Ownership"
              :items="ownerships"
              item-text="name"
              item-value="id"
              cache-items
              dense
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12">
            <v-text-field
              v-model="artwork_ownership_log.note"
              name="note"
              label="Note"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-menu
              v-model="menu2"
              :return-value.sync="artwork_ownership_log.change_date"
              ref="menu2"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              landscape
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                v-model="artwork_ownership_log.change_date"
                slot="activator"
                label="Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                persistent
                v-model="artwork_ownership_log.change_date"
                @input="$refs.menu2.save(artwork_ownership_log.change_date)"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
            <v-btn @click="showUpload = !showUpload">cancel</v-btn>
            <v-btn
              :dark="!(artwork_ownership_log.artwork_ownership_id == null || artwork_ownership_log.artwork_ownership_id == '') &&
                !(
                  artwork_ownership_log.copy == 'packings' &&
                  selectedPackings.length < 1
                )
              "
              @click="save_artwork_ownership_log"
              :disabled="
                (artwork_ownership_log.artwork_ownership_id == null || artwork_ownership_log.artwork_ownership_id == '') ||
                artwork_ownership_log.copy == 'packings' &&
                  selectedPackings.length < 1
              "
              >save</v-btn
            >
          </v-flex>
        </v-flex> -->
      </v-layout>

      <v-flex row xs12 sm12 md12 mt-0 ml-2 mr-2 v-if="c_user.edit && showList">
        <v-list
          class="xs12"
          v-if="
            artwork.artwork_ownership_logs &&
              artwork.artwork_ownership_logs.length > 0
          "
        >
          <!-- <v-flex> -->
            <template v-for="l in artwork.artwork_ownership_logs">
              <v-list-tile :key="l.id">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span v-if="l.artwork_ownership_id" class="subheading font-weight-bold"
                      >{{ getOwnershipName(l.artwork_ownership_id) }} </span
                    >
                    <span class="right" >
                      <span v-if="l.change_date != null"
                        >{{ format_date(l.change_date) }}</span
                      >
                    </span>
                    
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-if="l.note">
                    <span>{{ l.note }}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                  <span class="right">
                    <v-btn :key="l.id+'b'" small class="mr-0" icon @click="editExhibitionHistory(l)" >
                      <v-icon small color="black">edit</v-icon>
                    </v-btn>
                  </span>
              </v-list-tile>
              <v-divider class="my-2" :key="`a${l.id}`"></v-divider>
            </template>
          <!-- </v-flex> -->
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function(a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

import axios from '@/utils/apiClient';
export default {
  props: ["artwork"],
  data: () => ({
    editDialog: false,
    editedOwnershipHistory: {},
    artwork_ownership_history: {},
    selectedPackings: [],
    menu2: false,
    showUpload: false,
    showList: false,
    show: false,
    errors: "",
    artwork_ownership_log: {
      id: "",
      note: "",
      change_date: "",
      artwork_ownership_id: ""
    }
  }),
  computed: {
    ownerships() {
      return Object.assign([], this.$store.getters.my_ownerships).sort(
        dynamicSort("name")
      );
    },
  },
  methods: {
    editExhibitionHistory(l) {
      this.editedOwnershipHistory = l
      this.editDialog = true
    },
    save_edited_artwork_ownership_history() {
      this.editedOwnershipHistory.last_update_by = this.c_user.id;
      this.editedOwnershipHistory.artwork_id = this.artwork.id;
      axios
        .put(`${this.$globals.apiserver}/artwork_ownership_logs/${this.editedOwnershipHistory.id}.json`, {
          artwork_ownership_log: this.editedOwnershipHistory
        })
        .then(response => {
          this.$emit("getArtwork");
          this.errors = {};
          this.artwork.artwork_ownership_logs = [
            ...this.artwork.artwork_ownership_logs.filter(element => element.id !== response.data.id), response.data
          ];
          // this.artwork.artwork_ownership_id = this.editedOwnershipHistory.artwork_ownership_id;
          // this.active_artwork_ownership_logs = this.$store.state.artwork_ownership_logs;
          this.editedOwnershipHistory = {
            id: "",
            note: "",
            change_date: "",
            artwork_ownership_id: ""
          };
          this.editDialog = false
        })
        .catch(error => {
          // console.log(error);
        });
      // var aartwork_ownership_history = Object.keys(this.artwork_ownership_history).forEach(k => this.artwork_ownership_history[k]='')
      // console.log(aartwork_ownership_history)
    },
    // ownership_name(id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.getters.my_ownerships.find(l => l.id === id);
    //     if (a) {
    //       return a.name;
    //     } else {
    //       return "Ownership not found in CMS.";
    //     }
    //   } else {
    //     return "Ownership not found in CMS.";
    //   }
    // },
    // download() {},
    delete_log() {},
    save_artwork_ownership_log() {
      this.artwork_ownership_log.created_by = this.c_user.id;
      this.artwork_ownership_log.artwork_id = this.artwork.id;
      if (this.artwork_ownership_log.storage == "in") {
        this.artwork_ownership_log.storage_in = this.artwork_ownership_log.change_date;
      } else {
        this.artwork_ownership_log.storage_out = this.artwork_ownership_log.change_date;
      }
      // this.artwork_ownership_log.id = this.findMinMax(this.all_artwork_ownership_logs)+1
      if (!this.artwork.artwork_ownership_logs) {
        this.artwork.artwork_ownership_logs = [];
      }
      // this.$store.commit('ADD_TODO', this.artwork_ownership_log)
      // this.all_artwork_ownership_logs.push(this.artwork_ownership_log)
      if (
        this.artwork_ownership_log.copy == "packings" &&
        this.selectedPackings && this.selectedPackings.length > 0
      ) {
        // console.log('packings')
        for (const sp in this.selectedPackings) {
          // console.log(this.selectedPackings[sp].id)
          this.artwork_ownership_log.artwork_packing_id = this.selectedPackings[sp].id;
          // console.log(this.artwork_ownership_log);
          axios
            .post(`${this.$globals.apiserver}/artwork_ownership_logs.json`, {
              artwork_ownership_log: this.artwork_ownership_log
            })
            .then(response => {
              this.errors = {};
              // this.artwork.artwork_ownership_logs.push(response.data);
              // @artwork.artwork_ownership_id = @artwork_ownership_log.id
              // elsif @artwork_ownership_log.copy = 'master_physical'
              // @artwork.master_physical_ownership_id = @artwork_ownership_log.id
              // elsif @artwork_ownership_log.copy = 'archive_master'
              // @artwork.archive_master_ownership_id = @artwork_ownership_log.id
              // elsif @artwork_ownership_log.copy = 'access_copy'
              // @artwork.access_copy_ownership_id = @artwork_ownership_log.id
              // this.active_artwork_ownership_logs = this.artwork.artwork_ownership_logs
              this.$store.commit("ADD_LOG", response.data);
              this.active_artwork_ownership_logs = this.$store.state.artwork_ownership_logs;
              this.showUpload = !this.showUpload;
            })
            .catch(error => {
              // console.log(error);
              // this.errors = error.response.data;
            });
        }
        this.artwork_ownership_log = {
          storage: "in",
          note: "",
          change_date: "",
          copy: "artwork",
          shipper: "",
          reason: "",
          artwork_ownership_id: "",
          artwork_packing_id: ""
        };
      } else {
        // console.log('single')
        axios
          .post(`${this.$globals.apiserver}/artwork_ownership_logs.json`, {
            artwork_ownership_log: this.artwork_ownership_log
          })
          .then(response => {
            this.errors = {};
            this.artwork.artwork_ownership_logs.push(response.data);
            if (this.artwork_ownership_log.copy == "artwork") {
              this.artwork.artwork_ownership_id = this.artwork_ownership_log.artwork_ownership_id;
            } else if (this.artwork_ownership_log.copy == "master_physical") {
              this.artwork.master_physical_ownership_id = this.artwork_ownership_log.artwork_ownership_id;
            } else if (this.artwork_ownership_log.copy == "archive_master") {
              this.artwork.archive_master_ownership_id = this.artwork_ownership_log.artwork_ownership_id;
            } else if (this.artwork_ownership_log.copy == "access_copy") {
              this.artwork.access_copy_ownership_id = this.artwork_ownership_log.artwork_ownership_id;
            }
            this.$store.commit("ADD_LOG", response.data);
            this.active_artwork_ownership_logs = this.$store.state.artwork_ownership_logs;
            this.showUpload = !this.showUpload;
            this.artwork_ownership_log = {
              storage: "in",
              note: "",
              change_date: "",
              copy: "artwork",
              shipper: "",
              reason: "",
              artwork_ownership_id: "",
              artwork_packing_id: ""
            };
          })
          .catch(error => {
            // console.log(error);
          });
      }

      // var aartwork_ownership_log = Object.keys(this.artwork_ownership_log).forEach(k => this.artwork_ownership_log[k]='')
      // console.log(aartwork_ownership_log)
    }
  }
};
</script>

<style scoped>
/* .activeToggle { background-color: gold; color:hotpink; } */
</style>



// WEBPACK FOOTER //
// src/components/artworks/OwnershipHistory.vue